export default "__VITE_ASSET__DhWxICBD__"